import { render, staticRenderFns } from "./DropzoneContent.vue?vue&type=template&id=64a1743c&scoped=true&"
import script from "./DropzoneContent.vue?vue&type=script&lang=js&"
export * from "./DropzoneContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a1743c",
  null
  
)

export default component.exports